import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Icon, IconButton, TableCell, TableRow } from '@material-ui/core';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import EditEntityRuleDialog from '../dialogs/EditEntityRuleDialog';
import { useEntityContext } from '../EntityContext';
const StyledTableRow = styled(TableRow) `
  overflow: auto;
  vertical-align: top;
  .MuiTableCell-root {
    padding: 12px 8px 4px 8px;
  }
  .align {
    vertical-align: middle;
  }
  .rule-type {
    min-width: 180px;
  }
  &.dragging {
    opacity: 0.8;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
      0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  }
  .drag-cell {
    width: 40px;
  }
  .drag-handle {
    margin-top: 6px;
    cursor: grab;
    opacity: 0.25;
    transition: opacity 300ms;
    &:hover {
      opacity: 1;
    }
    svg {
      color: #bbb;
    }
  }
  code {
    font-size: 13px;
    background: #f4f5fa;
    padding: 0px 3px;
    border-radius: 3px;
    /* margin-right: 5px; */
  }
`;
export const EntityRuleListRow = ({ index, isDragging, entity, rule: initialRule, disabled, className }) => {
    const { trackChanges, rules } = useEntityContext();
    const [rule, setRule] = useState(initialRule);
    const [openDialog, setOpenDialog] = useState(false);
    useEffect(() => {
        setRule(initialRule);
    }, [initialRule]);
    // const handleRuleChange = (changedRule: EntityRuleSchema<any>) => {
    //   debounce(() => {
    // const keys = Object.keys(changedRule) as (keyof EntityRuleSchema<any>)[];
    // keys.forEach(key => {
    //   if (changedRule[key] !== rule[key]) {
    //     trackChanges.update(`rules[${index}].${key}`, changedRule[key]);
    //   }
    // });
    //   }, 300)();
    //   setRule(changedRule);
    // };
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
        id: isDragging ? '' : rule.name || ''
    });
    const classes = [className];
    isDragging && classes.push('dragging');
    const plugin = rules.find(plugin => plugin.type === (rule === null || rule === void 0 ? void 0 : rule.type));
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledTableRow, { hover: true, ref: setNodeRef, style: {
                opacity: isDragging ? 0.75 : undefined,
                transform: CSS.Translate.toString(transform),
                transition: transition || undefined
            }, className: classes.join(' '), onClick: () => setOpenDialog(true) },
            React.createElement(TableCell, Object.assign({ className: 'drag-cell', align: 'center' }, attributes, listeners),
                React.createElement(DragIndicatorIcon, { className: 'drag-handle' })),
            React.createElement(TableCell, { className: 'align' }, (plugin === null || plugin === void 0 ? void 0 : plugin.name) || 'Rule plugin not found'),
            React.createElement(TableCell, { className: 'align' }, (plugin === null || plugin === void 0 ? void 0 : plugin.display) ? (React.createElement(plugin.display, { rule: rule })) : ((plugin === null || plugin === void 0 ? void 0 : plugin.description) || '')),
            React.createElement(TableCell, { className: 'delete-cell align' },
                React.createElement(IconButton, { size: 'small', disabled: disabled, onClick: () => {
                        trackChanges.delete(`rules[${index}]`);
                        // TODO: unlock any rule specific columns and relations
                    } },
                    React.createElement(Icon, null, "delete_outlined")))),
        openDialog && (React.createElement(EditEntityRuleDialog, { open: true, entity: entity, rule: rule, onCancel: () => {
                console.log('onCancel');
                setOpenDialog(false);
            }, onChange: rule => {
                setOpenDialog(false);
                trackChanges.update(`rules[${index}]`, rule);
                setRule(rule);
            } }))));
};
export default EntityRuleListRow;
//# sourceMappingURL=EntityRuleListRow.js.map